





import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  data() {
    return {
      loading: true
    };
  },
  beforeRouteEnter(to, from, next) {
    if (Object.keys(to.query).length !== 0) {
      next(vm => {
        (vm as any).joinProject(vm, to.query.id, to.query.token);
      });
    }
  },
  destroyed() {},
  updated() {},
  watch: {},
  methods: {
    joinProject(vm, id, token) {
      vm.$store
        .dispatch("app/authenticateViaProjectInvitation", {
          invitationId: id,
          token: token
        })
        .then(response => {
          location.replace(window.location.origin + abp.appPath);
        })
        .finally(() => {
          vm.loading = false;
        });
    }
  }
});
